import packsConfig from './config/packs.json';

// Pack manifest source. The desktop shell uses `getRegisteredPacks()` to
// enumerate installable apps (id/name/icon) and wire them into the window
// renderer in `main.tsx`. Pack identity is the `id`. The bundle is fetched
// from `${serverUrl}/_apps/<id>/bundle.mjs` at runtime by `DynamicAppBundle`;
// npm is not consulted.
// TODO: retire once app discovery moves server-side (kernel-owned manifest).

export interface PackEntry {
	id: string;
	name: string;
	autoOpen?: boolean;
	icon?: string;
}

const packs: PackEntry[] = packsConfig as PackEntry[];

export function getRegisteredPacks(): PackEntry[] {
	return packs;
}
